import { Capacitor } from "@capacitor/core";
import { InAppReview } from "@capacitor-community/in-app-review";

const LAST_SHOWN_KEY = "avocash_review_last_shown";
const SUCCESS_COUNT_KEY = "avocash_review_success_count";

const MIN_SUCCESSES = 3;
const COOLDOWN_MS = 30 * 24 * 60 * 60 * 1000;

function isEligible() {
  if (!Capacitor.isNativePlatform()) return false;
  const count = Number(window.localStorage.getItem(SUCCESS_COUNT_KEY) || 0);
  if (count < MIN_SUCCESSES) return false;
  const lastShown = Number(window.localStorage.getItem(LAST_SHOWN_KEY) || 0);
  return Date.now() - lastShown > COOLDOWN_MS;
}

async function requestAppReview() {
  if (!isEligible()) return;
  window.localStorage.setItem(LAST_SHOWN_KEY, String(Date.now()));
  try {
    await InAppReview.requestReview();
  } catch (err) {
    // The store native prompt may still be suppressed by the OS; revert cooldown
    // so the user still gets prompted after their next successful transaction.
    window.localStorage.removeItem(LAST_SHOWN_KEY);
  }
}

export function useInAppReview() {
  /**
   * Call after a confirmed positive in-app experience (e.g. a successful
   * transaction). Apple forbids prompting on launch or during onboarding, so
   * this is gated to native platforms, a minimum number of successful
   * transactions, and a long cooldown between prompts.
   */
  function reportSuccessfulTransaction() {
    const count = Number(window.localStorage.getItem(SUCCESS_COUNT_KEY) || 0) + 1;
    window.localStorage.setItem(SUCCESS_COUNT_KEY, String(count));
    return requestAppReview();
  }

  return { reportSuccessfulTransaction };
}